export const colors = {
    primary: '#1E91D6',
    secondary: '#FC583F',
    dark: '#051923'
}

export const sizing = {
    fullWidth: '100%',
    contentWidth: '70%',
    contentMargins: '0 auto',
}

export const media = {
    desktop: '@media(max-width: 1300px)',
    tablet: '@media(max-width: 900px)',
    lgMobile: '@media(max-width: 750px)',
    mobile: '@media(max-width: 600px)',
    xs: '@media(max-width: 480px)',
    atomic: '@media(max-width: 420px)'
}